import { ICredentialsDecryptedResponse, ICredentialsResponse, IRestApiContext } from '@/Interface';
import { makeRestApiRequest, makeRestApiRequestN8n } from '@/api/helpers';
import {
	ICredentialsDecrypted,
	ICredentialType,
	IDataObject,
	NodeCredentialTestRequest,
	NodeCredentialTestResult,
} from 'n8n-workflow';

export async function getCredentialTypes(context: IRestApiContext): Promise<ICredentialType[]> {
	return await makeRestApiRequestN8n(context, 'GET', '/credential-types');
}

export async function getCredentialsNewName(context: IRestApiContext, name?: string): Promise<{name: string}> {
	return await makeRestApiRequest(context, 'GET', '/Credenciais/new', name ? { name } : {});
}

export async function getAllCredentials(context: IRestApiContext): Promise<ICredentialType[]> {
	return await makeRestApiRequestN8n(context, 'GET', '/credentials');
}

export async function createNewCredential(context: IRestApiContext, workspaceId: string, data: ICredentialsDecrypted): Promise<ICredentialsResponse> {
	return makeRestApiRequest(context, 'POST', `/Workspaces/${workspaceId}/Credenciais`, data as unknown as IDataObject);
}

export async function deleteCredential(context: IRestApiContext, id: string, workspaceId: string): Promise<boolean> {
	return makeRestApiRequest(context, 'DELETE', `/Workspaces/${workspaceId}/Credenciais/${id}`);
}

export async function updateCredential(context: IRestApiContext, id: string, workspaceId: string, data: ICredentialsDecrypted): Promise<ICredentialsResponse> {
	return makeRestApiRequest(context, 'PATCH', `/Workspaces/${workspaceId}/Credenciais/${id}`, data as unknown as IDataObject);
}

export async function getCredentialData(context: IRestApiContext, id: string, workspaceId: string): Promise<ICredentialsDecryptedResponse | ICredentialsResponse | undefined> {
	return makeRestApiRequest(context, 'GET', `/Workspaces/${workspaceId}/Credenciais/${id}`);
}

// Get OAuth1 Authorization URL using the stored credentials
export async function oAuth1CredentialAuthorize(context: IRestApiContext, data: ICredentialsResponse): Promise<string> {
	return makeRestApiRequestN8n(context, 'GET', `/oauth1-credential/auth`, data as unknown as IDataObject);
}

// Get OAuth2 Authorization URL using the stored credentials
export async function oAuth2CredentialAuthorize(context: IRestApiContext, data: ICredentialsResponse): Promise<string> {
	return makeRestApiRequestN8n(context, 'GET', `/oauth2-credential/auth`, data as unknown as IDataObject);
}

export async function testCredential(context: IRestApiContext, data: NodeCredentialTestRequest): Promise<NodeCredentialTestResult> {
	return makeRestApiRequestN8n(context, 'POST', '/credentials-test', data as unknown as IDataObject);
}
